import { fetchData } from '../helpers/network';
import { ResponseInitial } from '../types/initial';
import axios from 'axios';

const initialApi = {
   fetchInitialData: () => fetchData<ResponseInitial>('/init'),
   fetchPartner: () => axios.get(`https://promo.bronui.com/api/partners/?block=footer`),
};

export default initialApi;